<main class="col-xl-6 col-md-10 col-sm-12">
    <h3>
        Acesso negado!
    </h3>
    <br>
    <section>
        Desculpe! Mas esta página possui acesso restrito!
    </section>
    <br>
    <button class="btn btn-primary" (click)="redirect()">
        Voltar para o login
    </button>
</main>
